<template>
  <div class="answer-progress">
    <div class="top">
      <div class="answer-breadcrumb">
        <el-breadcrumb class="breadcrumb" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item class="lable">{{courseName}}</el-breadcrumb-item>
          <!-- <el-breadcrumb-item></el-breadcrumb-item>
          <el-breadcrumb-item>第一章   会计概念、职能和目标</el-breadcrumb-item> -->
        </el-breadcrumb>
        <div class="count-time" v-if="finished === 0">
          <img class="icon-alarm-clock" src="../../assets/images/icons/icon-task-time.png" />
          <div class="clock-txt">
            {{showTime}}
          </div>
        </div>
      </div>
      <div class="progress-box">
        <el-progress class="progress" id="task-progress" :show-text="false" :stroke-width="14" :percentage="percentage"></el-progress>
        <div class="degree-of-completion">
          <div class="doned">已完成{{completeNumber}}题</div>
          <div class="total">/共{{questionNum}}题</div>
        </div>
      </div>
    </div>
    <!-- <div class="answer-breadcrumb-right" @click="goBack">
      <img class="icon-back" src="../../assets/images/icons/icon-task-go-back.png" />
      <div class="txt">返回</div>
    </div> -->
  </div>
</template>

<script>

export default {
  name: 'answerTop',
  data () {
    return {
      courseName: this.$route.query.name
    }
  },
  computed: {
    questionNum() {
      return this.$store.state.questions.questionNum;
    },
    completeNumber() {
      if(this.finished === 1) {
        return this.questionNum;
      }else {
        let num = Object.keys(this.$store.state.questions.answers).length;
        return Object.keys(this.$store.state.questions.answers).length;
      }
    },
    percentage() {
      if(this.finished === 1) {
        return 100
      }else {
        let num = Object.keys(this.$store.state.questions.answers).length;
        return Math.floor((num / this.questionNum) * 100) || 0;
      }
    },
    finished() {
      return this.$store.state.questions.finished;
    },
    showTime() {
      return this.$store.state.questions.showTime;
    },
  },
  beforeDestroy() {
    this.$store.dispatch('questions/closeTimer');
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '../../assets/css/style.scss';
  .answer-progress {
    height: 101px;
    margin: 20px 0;
    background: #fff;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.05);
    @include flex-between();

    .top {
      width: 1200px;
      margin: 18px 0 0 20px;

      .answer-breadcrumb {
        @include flex-between();
        .breadcrumb {
          margin-bottom: 22px;
          .lable {
            padding-left: 12px;
            position: relative;
            &::before {
              content: '';
              display: block;
      
              width: 4px;
              height: 20px;
              background: $answer-primary;
      
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
            }
            
          }
        }

        .count-time {
          width: 90px;
          height: 24px;
          margin-right: 36px;
          background: rgba(252, 141, 64, .1);
          border-radius: 12px;
          @include flex-vertical-center();

          .icon-alarm-clock {
            width: 15px;
            height: 14px;
            margin: 0 6px 0 15px;
          }

          .clock-txt {
            font-size: 14px;
            font-weight: 500;
            color: #FC8D40;
            line-height: 24px;
          }
        }
      }
      
      
    }

    .progress-box {
      @include flex-between-and-vertical-center();

      .progress {
        width: 900px;
      }

      .degree-of-completion {
        margin-right: 36px;
        @include flex-vertical-center();
        .doned {
          font-size: 16px;
          color: #FC8D40;
        }
        .total {
          margin-left: 4px;
          font-size: 14px;
          color: #999999;
        }
      }
    }

    .answer-breadcrumb-right {
      width: 104px;
      padding-top: 31px;
      text-align: center;
      position: relative;
      cursor: pointer;

      &::before {
        content: '';
        display: block;

        width: 1px;
        height: 69px;
        
        position: absolute;
        left: 0;
        top: 16px;

        background: #F0F0F0;
      }

      .icon-back {
        width: 22px;
        height: 12px;
        margin: 0 auto 8px;
        display: block;
      }
      .txt {
        font-size: 14px;
        
        color: $answer-text-primary;
      }
    }

  }
</style>
<style lang="scss">
#task-progress {
  width: 980px;
  .el-progress-bar__outer {
    border: 1px solid #F8D5BC;
    background-color: #FFF5EF;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/questions/answerTop.vue